import React from "react";
import SimpleReactLightbox from "simple-react-lightbox";
import { HelmetProvider } from "react-helmet-async";

export const wrapRootElement = ({ element }) => {
  return (
    <HelmetProvider>
      <SimpleReactLightbox>{element}</SimpleReactLightbox>
    </HelmetProvider>
  );
};
